<template>
    <MaskLayout :isShow="calendarShow" @closeMask="closecalendarT" :contentStyle="calendarStyle" :animationToTop="true">
            <div class="page-wrapper page-overflow-hidden padding30">
                <p class="page-text-center page-margin-bottom2">请选择日期</p>
                <div class="page-wrapper calendar-content-wrapper">
                    <Calendar
                      v-if="refresh"
                      :events="events"
                      :disabled="disabledarr"
                      :begin="begin"
                      :end="end"
                      @select="select"
                    ></Calendar>
                </div>
                <div class="page-margin-top3 movie-box page-text-center movie-gradient calendar-button" @click="confirmCalendar">确认</div>
            </div>
        </MaskLayout>
</template>

<script>
import MaskLayout from "@components/MaskLayout.vue";
import Calendar from "mpvue-calendar";
import "mpvue-calendar/src/browser-style.css";
// import "mpvue-calendar/src/style.css";
import { addNumberBeforeZero } from "@utils/movie.js";
export default {
    name: "TicketCalendar",
    components: {
        MaskLayout,
        Calendar
    },
    props: {
        calendarShow: {
            type: Boolean,
            default: false
        },
        datas: {
            type: Array,
            default: ()=>[]
        }
    },
    watch: {
        datas: {
            handler: function (newVal) {
                if (newVal.length == 0) return;
                let eventArr = newVal || [];
                let objEvent = {};
                this.original_list = JSON.parse(JSON.stringify(newVal));//保存下原先的数据
                newVal && newVal.forEach(item => {
                    if (item._isShow) {
                       objEvent[`${String(item.date)}`]=String(item.price); 
                    } else {
                        this.disabledarr.push(item.date)
                    }
                });
                this.events = objEvent;
                this.begin = eventArr[0].date.split('-').map((val)=>parseInt(val));
                this.end = eventArr[eventArr.length-1].date.split('-').map((val)=>parseInt(val));

                this.refresh = false;
                this.$nextTick(()=>{
                    this.refresh = true;
                });
            },
            deep: true,
            immediate: true
        }
    },
    data: function() {
        return {
            calendarStyle: {
                width: "100%",
                height: "8rem",
                left: "0%",
                bottom: "0",
                "z-index": "111",
                "border-radius": ".2rem .2rem 0 0"
            },
            original_list: [],
            disabledarr: [],//['2021-7-5'],
            begin:[],//[2021,6,29],
            end:[],//[2021,7,8]
            events: {}, //{'2021-6-29':'110'}
            selectDate: "",
            price: "",
            refresh: true //防止第一次打开日历时'开始'和'结束'日期没刷新/没接收到新的值
        }
    },
    methods: {
        select(val, val2) {
            let{ date, event } = val2;
            this.selectDate = date.split('-').map((item)=>{
                return addNumberBeforeZero(item);
            }).join('-');
            this.price = event;
            // console.log(val, val2, "选择日期");
        },

        closecalendarT: function (val) { //取消
            let data = {
                close: val
            };
            this.$emit('closeCalendar', data);
        },
        confirmCalendar: function () { //确认
            if (!this.price) return this.$dialog.error("请重新选择！");
            let data = {
                close: false,
                date: this.selectDate,
                price: this.price
            };
            this.original_list && this.original_list.forEach((item)=>{
                let it = item.date.split('-').map((item)=>{
                    return addNumberBeforeZero(item);
                }).join('-');
                if (this.selectDate == it) {
                    data.show = item._isShow;
                    data._date = item._date;
                    data._price_self = item._price_self;
                };
            });
            // console.log(data,"data-data");
            this.$emit('closeCalendar', data);
        }
    }
}
</script>

<style scoped>
.calendar-content-wrapper {
    height: 5.9rem;
}
.calendar-button {
    height: .7rem;
    line-height: .7rem;
    color: #fff;
    border-radius: .2rem;
}
.calendar-content-wrapper .mpvue-calendar .selected .calendar-date {
    border-radius: 0;
    background: #FF5A5F;
    color: #fff;
}
.calendar-content-wrapper .mpvue-calendar {
    min-width: 100%;
}
</style>